<div id="shawarmer">
  <div class="shawarmer_banner" >
    <div class="go_button shawarmer sm square" (click)="multidialog('share')" style="position:absolute; top:20px; left:20px; z-index: 3;">
      <div class="snow share"></div>
      <i class="icon-share" >Share</i>
    </div>

      <img class="shawarmer-logo" src="assets/img/shawarmer/shawarmer-logo.png" alt="">

    <img src="assets/img/shawarmer/shawarmer-banner2.jpg" class="img-responsive hidden-xs" alt="">

    <img src="assets/img/shawarmer/shawarmer-banner-mobile.jpg" class="img-responsive hidden-sm hidden-lg hidden-md" alt="">

    <div routerLink="./fifa" class="shawarmer-banner-overlay r" [class.active]="isLinkActive('fifa')">
      <div class="logo">
        <!--<img src="assets/img/games/fifa/logo.png" width="100" alt="">-->
      </div>
      <!--<div class="title">-->
        <!--مجموع جوائز 58،000 ريال سعودي-->
      <!--</div>-->

    </div>
    <div  routerLink="./tekken-7"  class="shawarmer-banner-overlay l" [class.active]="isLinkActive('tekken-7')"></div>
    <div routerLink="./fortnite"  class="shawarmer-banner-overlay top" [class.active]="isLinkActive('fortnite')"></div>


  </div>

  <!--<div class="shawarmerLights"></div>-->


  <div class="go_button orange sm square" style="position:absolute; top:20px; left:20px;">
    <i class="icon-facebook" (click)="eventService.shareEvent()">Share</i>
  </div>

  <perfect-scrollbar class="games-container">
    <div class="flex_block">
    <a class="games_block" *ngFor="let game of games" routerLink="./{{game}}"  [class.active]="isLinkActive(game)"
       [ngStyle]="{'background-image': 'url(assets/img/shawarmer/games/'+game+'/sm.jpg)'}" >
      <span class="game-block-overlay {{game}}" routerLinkActive="active" routerLink="./{{game}}" ></span>
        <img src="assets/img/games/{{game}}/logo.png"  alt="" style="z-index: 1">
    </a>
    </div>
  </perfect-scrollbar>

  <div class="container">
    <div class="description">
      <p>شارك الآن في Shawarmer League أضخم بطولة جغرافية على مستوى المملكة في ألعاب الفيديو و الرياضة الإلكترونية.
        البطولة مصرحة رسميا من الإتحاد السعودي للرياضات الذهنية و الإلكترونية و تقام في 3 ألعاب مختلفة:

        , FIFA 20, TEKKEN 7, FORTNITE

        البطولة تتيح للعديد من اللاعبين من مناطق مختلفة في المملكة للمشاركة فيها (الجبيل - الدمام - أبها - المدينة - تبوك - جدة - بريدة - الرياض). يمكنك المشاركة
        و الفوز على مستوى مدينتك للتأهل للنهائي الكبير في الرياض و فرصة ربح جوائز يصل مجموعها الى 150 ألف ريال سعودي.</p>
    </div>
  <div class="row">
      <router-outlet></router-outlet>
    </div>
  </div>
  <!--footer-->
  <div class="shawarmer_footer">
    <a href="https://www.gbarena.com" target="_blank" class="gbarena"><img src="assets/img/GBarena-type.svg" style="width: 80px" alt="GBarena Logo"></a>
    <p style="text-transform: uppercase">Shawarmer League event is hosted on GBarena <br> ALL TERMS & CONDITIONS APPLY</p>
  </div>

  <div class="bottom-menu">
    <div class="items logo">
      <img src="assets/img/shawarmer/shawarmer-logo.png" alt="">
    </div>
    <perfect-scrollbar [scrollIndicators]="true" class="scroll-menu-container">
      <div class="inner-container">
    <div class="items" (click)="multidialog('rules')">القواعد العامة</div>
    <div class="items" (click)="multidialog('contact')">التواصل معنا</div>
    <!--<div class="items">كيفية الاشتراك</div>-->
    <div class="items" (click)="multidialog('prizes')">الجوائز</div>
      </div>
    </perfect-scrollbar>
  </div>
</div>
